import { Link } from "react-router-dom";
import collage from "../images/collage-two.png";
import { Markdown, MarkdownParagraphs } from "../components/Markdown";
import {
  aboutTitle,
  heroCtaLabel,
  history,
  historyHeading,
  pointsOfUnity,
  pointsOfUnityHeading,
  pointsOfUnityIntro,
} from "../content";
import "../styles/page.css";

function About() {
  return (
    <main id="main-content" tabIndex={-1} className="page">
      {/* Light masthead: the points below are on the dark ground, so this hands
          off to a contrasting band rather than merging into it. */}
      <header className="page__masthead page__masthead--light">
        <div className="page__masthead-inner">
          <h1 className="page__title">{aboutTitle}</h1>
        </div>
      </header>

      {/* Breathing room between the masthead and the points, on the cream the
          collage's dark line art needs. */}
      <div className="page__frieze">
        <img
          className="page__frieze-image"
          src={collage}
          alt="An illustrated crowd of DAWC protesters carrying signs reading “No war,” “Stop U.S. intervention,” and a banner reading “No war with Venezuela — money for Detroit, not for war — divest now.”"
        />
      </div>

      <section className="bands-section">
        <div className="bands-section__intro">
          <h2 className="bands-section__title">{pointsOfUnityHeading}</h2>
          <p className="bands-section__lede">{pointsOfUnityIntro}</p>
        </div>

        <ol className="bands">
          {pointsOfUnity.map((point, i) => (
            <li key={point.id} id={point.id} className="band">
              <div className="band__inner">
                {/* Number and point lead the left column, the way the demands
                    do on Detroit Divest; the explainers answer from the right. */}
                <div className="band__lead">
                  <span className="band__num" aria-hidden="true">
                    {i + 1}
                  </span>
                  <h3 className="band__heading">
                    <Markdown>{point.heading}</Markdown>
                  </h3>
                </div>
                <div>
                  {point.faqs.map((faq) => (
                    <div key={faq.q} className="band__faq">
                      <p className="band__q">{faq.q}</p>
                      <p className="band__a">
                        <Markdown>{faq.a}</Markdown>
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section className="page__section">
        <h2 className="page__heading">{historyHeading}</h2>
        <div className="page__prose">
          <MarkdownParagraphs items={history} />
        </div>
      </section>

      <div className="page__outro">
        <Link className="page__cta" to="/join-us">
          {heroCtaLabel}
        </Link>
      </div>
    </main>
  );
}

export default About;
